module.exports = __webpack_public_path__ + "img/message-gou.3623ad60.svg";